import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dropdown } from 'react-bootstrap'
import * as S from './styles'

const mapStatus = (status: number): 'Cadastrado' | 'Convidado' => {
  return status === 1 ? 'Cadastrado' : 'Convidado';
}

// Interface for member data
export interface IMember {
  id: string
  name: string
  email: string
  status: number,
  cityHallId: string
}

interface MembersTableProps {
  members: IMember[]
  onNotify: (member: IMember) => void
  onRemove: (member: IMember) => void
}

export const MembersTable = ({ members, onNotify, onRemove }: MembersTableProps): JSX.Element => {
  const isEmpty = members.length === 0

  return (
    <S.TableContainer>
      <S.TableHead>
        <div>Nome</div>
        <div>Email</div>
        <div>Status</div>
        <div style={{ textAlign: 'right' }}>Ações</div>
      </S.TableHead>
      {isEmpty ? (
        <S.TableRow style={{ display: 'block', padding: '40px', textAlign: 'center' }}>
          <div>Ainda não há membros cadastrados</div>
        </S.TableRow>
      ) : (
        members.map((member) => (
          <S.TableRow key={member.id}>
            <S.RowValue>{member.name}</S.RowValue>
            <S.RowValue>{member.email}</S.RowValue>
            <S.StatusText>{mapStatus(member.status)}</S.StatusText>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <S.ActionsDropdownButton
                id={`dropdown-actions-${member.id}`}
                title={<FontAwesomeIcon icon={['fas', 'ellipsis-vertical']} style={{ color: '#0066B3' }} />}
                variant="link"
              >
                <Dropdown.Item onClick={() => onNotify(member)}>
                  <FontAwesomeIcon icon={['fas', 'envelope']} className="me-2" />
                  Notificar novamente
                </Dropdown.Item>
                <Dropdown.Item onClick={() => onRemove(member)}>
                  <FontAwesomeIcon icon={['fas', 'trash']} className="me-2" />
                  Remover membro
                </Dropdown.Item>
              </S.ActionsDropdownButton>
            </div>
          </S.TableRow>
        ))
      )}
    </S.TableContainer>
  )
}